import React from 'react';
import { makeStyles, Box, Theme } from '@material-ui/core';
import { defaultProjections, EntrepreneurProfileBody } from '../../types/types';
import EditPencil from '../../components/EditPencil';
import { StyledText } from '../../components/StyledText';
import { getYear5Revenue } from '../../lib';
import { formatDollarsAsMillions } from '../../lib/utils';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    background: '#FFFFFF',
    border: '1px solid #DAD9DF',
    borderRadius: 8,
    padding: 20,
    [theme.breakpoints.up('md')]: {
      padding: 35
    },
    display: 'flex',
    flexDirection: 'column',
    '& .finance-label': {
      margin: '10px 0'
    }
  }
}));

interface EntrepreneurFinancePanelProps {
  profile: EntrepreneurProfileBody
  editable: boolean
  openEdit?: () => void
}

const EntrepreneurFinancePanel: React.FC<EntrepreneurFinancePanelProps> = ({
  profile,
  editable,
  openEdit
}) => {
  const {
    currentRevenue,
    financeRaised,
    financeSoughtLow,
    financeSoughtHigh,
    financialProjection = defaultProjections
  } = profile;
  const styles = useStyles();
  const financeRange = (financeSoughtLow && financeSoughtHigh) ? `${formatDollarsAsMillions(financeSoughtLow)} - ${formatDollarsAsMillions(financeSoughtHigh)}` : null;
  const fifthYearProjection = getYear5Revenue(financialProjection);
  return (
    <Box className={styles.root}>
      {editable && <EditPencil onClick={openEdit} style={{ right: 10, top: 10, position: 'absolute' }} />}
      <StyledText variant='h2' color='textPrimary'>Financial Summary</StyledText>
      <Box className='finance-label'>
        <StyledText variant='body1' color='textSecondary'>Funding sought</StyledText>
        <StyledText variant='h2' color={financeRange ? 'primary' : 'textSecondary'}>
          {financeRange || '$_'}
        </StyledText>
      </Box>
      <Box display='flex' flexWrap='wrap' justifyContent='space-between'>
        <Box className='finance-label'>
          <StyledText color='textSecondary'>
            Current Revenue
          </StyledText>
          <StyledText variant='h2' color={currentRevenue ? 'primary' : 'textSecondary'}>
            {currentRevenue ? formatDollarsAsMillions(currentRevenue) : '$_'}
          </StyledText>
        </Box>
        <Box className='finance-label'>
          <StyledText color='textSecondary'>
            Raised Already
          </StyledText>
          <StyledText variant='h2' color={financeRaised ? 'primary' : 'textSecondary'}>
            {financeRaised ? formatDollarsAsMillions(financeRaised) : '$_'}
          </StyledText>
        </Box>
      </Box>
      <Box className='finance-label'>
        <StyledText color='textSecondary'>
          Year 5 Projected Revenue
        </StyledText>
        <StyledText variant='h2' color={fifthYearProjection ? 'primary' : 'textSecondary'}>
          {fifthYearProjection ? formatDollarsAsMillions(fifthYearProjection) : '$_'}
        </StyledText>
      </Box>
    </Box>
  );
};

export default EntrepreneurFinancePanel;
